export enum WidgetAction {
    VALUATION = 'valuation',
    AGENT = 'agent',
    INFORMATION = 'information',
    WIDGET_OPEN = 'widget_open',
    WIDGET_CLOSE = 'widget_close',
    CHECKLIST = 'checklist',
}

export const WidgetIframeUrls: { [k in WidgetAction]?: string } = {
    valuation: '/appraisal',
    agent: '/agent_costs',
    information: '/information',
    checklist: '/checklist',
}
